import type User from 'modules/core/store/models/User'

import hasRegularAccess from 'modules/employees/lib/hasRegularAccess'

export default function usersWithRegularAccess(users: User[]): User[] {
  return users.filter((user) => {
    if (!user.employee) return true

    return hasRegularAccess(user.employee.attributes.has_regular_access)
  })
}
